import type { SVGProps } from "react"

const Invoice = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 3435" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 8909" clipPath="url(#prefix__a)">
      <path data-name="Path 60023" d="M175 0A175 175 0 110 175 175 175 0 01175 0" fill="#fff" />
      <path
        data-name="Path 60024"
        d="M264.371 310.43H84.009a8.047 8.047 0 01-8.047-8.047V40.632a8.047 8.047 0 018.047-8.047h180.362a8.047 8.047 0 018.047 8.047v261.751a8.047 8.047 0 01-8.047 8.047"
        fill="#fff"
      />
      <path
        data-name="Path 60025"
        d="M264.37 311.931H84.008a9.557 9.557 0 01-9.546-9.547V40.633a9.557 9.557 0 019.546-9.547H264.37a9.557 9.557 0 019.547 9.547v261.751a9.557 9.557 0 01-9.547 9.547M84.008 34.086a6.554 6.554 0 00-6.546 6.547v261.751a6.554 6.554 0 006.546 6.547H264.37a6.553 6.553 0 006.547-6.547V40.633a6.553 6.553 0 00-6.547-6.547z"
        fill="#1d1d1b"
      />
      <path data-name="Path 60026" d="M210.22 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60027" d="M214.017 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60028" d="M217.814 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60029" d="M221.611 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
      <path data-name="Path 60030" d="M206.423 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60031" d="M210.22 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60032" d="M206.423 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60033" d="M202.626 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60034" d="M214.017 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60035" d="M217.814 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60036" d="M221.611 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
      <path data-name="Path 60037" d="M225.407 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60038" d="M229.2 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60039" d="M233 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60040" d="M236.8 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60041" d="M240.6 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60042" d="M225.407 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60043" d="M229.2 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60044" d="M233 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60045" d="M236.8 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60046" d="M240.6 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60047" d="M244.392 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60048" d="M248.189 316.466a.475.475 0 10.474.475.474.474 0 00-.474-.475" fill="#1d1d1b" />
      <path data-name="Path 60049" d="M251.986 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
      <path data-name="Path 60050" d="M255.782 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60051" d="M259.579 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60052" d="M244.392 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60053" d="M248.189 312.669a.475.475 0 10.474.476.475.475 0 00-.474-.476" fill="#1d1d1b" />
      <path data-name="Path 60054" d="M251.986 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
      <path data-name="Path 60055" d="M255.782 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60056" d="M259.579 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60057" d="M263.376 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60058" d="M267.173 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60059" d="M270.97 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60060" d="M274.767 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60061" d="M263.376 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60062" d="M267.173 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60063" d="M270.97 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60064" d="M274.767 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60065" d="M138.079 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60066" d="M141.876 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60067" d="M145.673 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60068" d="M149.47 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60069" d="M134.283 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
      <path data-name="Path 60070" d="M138.079 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60071" d="M134.283 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
      <path data-name="Path 60072" d="M130.486 312.669a.475.475 0 10.474.476.476.476 0 00-.474-.476" fill="#1d1d1b" />
      <path data-name="Path 60073" d="M141.876 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60074" d="M145.673 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60075" d="M149.47 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60076" d="M153.267 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60077" d="M157.064 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60078" d="M160.86 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60079" d="M164.657 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60080" d="M168.454 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60081" d="M153.267 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60082" d="M157.064 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60083" d="M160.86 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60084" d="M164.657 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60085" d="M168.454 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60086" d="M172.251 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60087" d="M176.048 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60088" d="M179.845 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60089" d="M183.642 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60090" d="M187.439 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60091" d="M172.251 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60092" d="M176.048 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60093" d="M179.845 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60094" d="M183.642 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60095" d="M187.439 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60096" d="M84.923 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60097" d="M88.72 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60098" d="M92.517 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60099" d="M96.314 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60100" d="M81.126 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60101" d="M84.923 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60102" d="M81.126 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60103" d="M77.329 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60104" d="M88.72 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60105" d="M92.517 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60106" d="M96.314 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60107" d="M100.11 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60108" d="M103.907 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60109" d="M107.7 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60110" d="M111.5 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60111" d="M115.3 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60112" d="M100.11 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60113" d="M103.907 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60114" d="M107.7 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60115" d="M111.5 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60116" d="M115.3 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60117" d="M119.1 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60118" d="M122.892 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60119" d="M126.689 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60120" d="M130.486 316.466a.475.475 0 10.474.475.475.475 0 00-.474-.475" fill="#1d1d1b" />
      <path data-name="Path 60121" d="M119.1 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60122" d="M122.892 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60123" d="M126.689 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60124" d="M191.236 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60125" d="M195.032 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60126" d="M198.829 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60127" d="M202.626 316.466a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60128" d="M191.236 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60129" d="M195.032 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60130" d="M198.829 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60131" d="M278.563 312.669a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60132" d="M274.767 308.873a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60133" d="M278.563 308.873a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60134" d="M274.767 305.076a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60135" d="M278.563 305.076a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60136" d="M274.767 301.279a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60137" d="M274.767 297.482a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60138" d="M278.563 301.279a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60139" d="M278.563 297.482a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60140" d="M274.767 293.685a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60141" d="M278.563 293.685a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60142" d="M274.767 289.888a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60143" d="M278.563 289.888a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60144" d="M274.767 286.091a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60145" d="M278.563 286.091a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60146" d="M274.767 282.3a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60147" d="M274.767 278.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60148" d="M278.563 282.3a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60149" d="M278.563 278.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60150" d="M274.767 274.7a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60151" d="M278.563 274.7a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60152" d="M274.767 270.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60153" d="M278.563 270.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60154" d="M274.767 267.107a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60155" d="M278.563 267.107a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60156" d="M274.767 263.31a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60157" d="M278.563 263.31a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60158" d="M274.767 259.513a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60159" d="M278.563 259.513a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60160" d="M274.767 255.716a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60161" d="M274.767 251.92a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60162" d="M278.563 255.716a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60163" d="M278.563 251.92a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60164" d="M274.767 248.123a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60165" d="M278.563 248.123a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60166" d="M274.767 244.326a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60167" d="M278.563 244.326a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60168" d="M274.767 240.529a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60169" d="M278.563 240.529a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60170" d="M274.767 236.732a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60171" d="M274.767 232.935a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60172" d="M278.563 236.732a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60173" d="M278.563 232.935a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60174" d="M274.767 229.138a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60175" d="M278.563 229.138a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60176" d="M274.767 225.341a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60177" d="M278.563 225.341a.475.475 0 10.475.476.476.476 0 00-.475-.476" fill="#1d1d1b" />
      <path data-name="Path 60178" d="M274.767 221.545a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60179" d="M278.563 221.545a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60180" d="M274.767 217.748a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60181" d="M278.563 217.748a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60182" d="M278.563 213.951a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60183" d="M274.767 213.951a.476.476 0 10.437.29.475.475 0 00-.437-.29" fill="#1d1d1b" />
      <path
        data-name="Path 60184"
        d="M274.767 210.154a.475.475 0 00-.475.475.475.475 0 00.95 0 .475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path data-name="Path 60185" d="M278.563 210.154a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60186" d="M274.767 206.357a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60187" d="M278.563 206.357a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60188" d="M274.767 202.56a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60189" d="M278.563 202.56a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60190" d="M274.767 198.763a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60191" d="M274.767 194.967a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60192" d="M278.563 198.763a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60193" d="M278.563 194.967a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60194" d="M274.767 191.17a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60195" d="M278.563 191.17a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60196" d="M274.767 187.373a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60197" d="M278.563 187.373a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60198" d="M274.767 183.576a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60199" d="M278.563 183.576a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60200" d="M274.767 179.779a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60201" d="M274.767 175.982a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60202" d="M278.563 179.779a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60203" d="M278.563 175.982a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60204" d="M274.767 172.185a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60205" d="M278.563 172.185a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60206" d="M274.767 168.388a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60207" d="M278.563 168.388a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60208" d="M274.767 164.592a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60209" d="M278.563 164.592a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60210" d="M274.767 160.795a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60211" d="M278.563 160.795a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60212" d="M274.767 157a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60213" d="M278.563 157a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60214" d="M274.767 153.2a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60215" d="M274.767 149.4a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60216" d="M278.563 153.2a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60217" d="M278.563 149.4a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60218" d="M274.767 145.607a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60219" d="M278.563 145.607a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path
        data-name="Path 60220"
        d="M274.767 141.81a.475.475 0 00-.475.475V142.298a.475.475 0 00.95 0V142.285a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path data-name="Path 60221" d="M278.563 141.81a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path
        data-name="Path 60222"
        d="M274.767 138.014a.475.475 0 00-.475.475V138.502a.475.475 0 10.95 0V138.489a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60223"
        d="M278.563 138.014a.475.475 0 00-.475.475V138.502a.475.475 0 10.95 0V138.489a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60224"
        d="M274.767 134.217a.475.475 0 00-.475.475V134.705a.475.475 0 00.95 0V134.692a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60225"
        d="M274.767 130.42a.475.475 0 00-.475.475V130.908a.475.475 0 00.95 0V130.895a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60226"
        d="M278.563 134.217a.475.475 0 00-.475.475V134.705a.475.475 0 10.95 0V134.692a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60227"
        d="M278.563 130.42a.475.475 0 00-.475.475V130.908a.475.475 0 10.95 0V130.895a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60228"
        d="M274.767 126.623a.475.475 0 00-.475.475V127.111a.475.475 0 00.95 0V127.098a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60229"
        d="M278.563 126.623a.475.475 0 00-.475.475V127.111a.475.475 0 10.95 0V127.098a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60230"
        d="M274.767 122.826a.475.475 0 00-.475.475V123.314a.475.475 0 00.95 0V123.301a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60231"
        d="M278.563 122.826a.475.475 0 00-.475.475V123.314a.475.475 0 10.95 0V123.301a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60232"
        d="M274.767 119.029a.475.475 0 00-.475.475V119.517a.475.475 0 00.95 0V119.504a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60233"
        d="M278.563 119.029a.475.475 0 00-.475.475V119.517a.475.475 0 10.95 0V119.504a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60234"
        d="M274.767 115.232a.475.475 0 00-.475.475V115.72a.475.475 0 00.95 0V115.707a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60235"
        d="M278.563 115.232a.475.475 0 00-.475.475V115.72a.475.475 0 10.95 0V115.707a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60236"
        d="M274.767 111.436a.475.475 0 00-.475.475V111.924a.475.475 0 00.95 0V111.911a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60237"
        d="M278.563 111.436a.475.475 0 00-.475.475V111.924a.475.475 0 10.95 0V111.911a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60238"
        d="M274.767 107.639a.475.475 0 00-.475.475V108.127a.475.475 0 00.95 0V108.114a.475.475 0 00-.475-.475"
        fill="#1d1d1b"
      />
      <path data-name="Path 60239" d="M274.767 103.855a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60240" d="M278.563 107.652a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60241" d="M278.563 103.855a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60242" d="M274.767 100.058a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60243" d="M278.563 100.058a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60244" d="M274.767 96.262a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60245" d="M278.563 96.262a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60246" d="M274.767 92.465a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60247" d="M278.563 92.465a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60248" d="M274.767 88.668a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60249" d="M278.563 88.668a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60250" d="M274.767 84.871a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60251" d="M278.563 84.871a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60252" d="M274.767 81.074a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60253" d="M274.767 77.277a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60254" d="M278.563 81.074a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60255" d="M278.563 77.277a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60256" d="M274.767 73.48a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60257" d="M278.563 73.48a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60258" d="M274.767 69.683a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60259" d="M278.563 69.683a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60260" d="M274.767 65.887a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60261" d="M278.563 65.887a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60262" d="M274.767 62.09a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60263" d="M274.767 58.293a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60264" d="M278.563 62.09a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60265" d="M278.563 58.293a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60266" d="M274.767 54.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60267" d="M278.563 54.5a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60268" d="M274.767 50.7a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60269" d="M278.563 50.7a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60270" d="M274.767 46.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60271" d="M278.563 46.9a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60272" d="M274.767 43.1a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60273" d="M278.563 43.1a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60274" d="M274.767 39.309a.475.475 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path data-name="Path 60275" d="M278.563 40.258a.475.475 0 10-.475-.475.475.475 0 00.475.475" fill="#1d1d1b" />
      <path data-name="Path 60276" d="M274.767 35.512a.474.474 0 10.475.475.475.475 0 00-.475-.475" fill="#1d1d1b" />
      <path
        data-name="Path 60277"
        d="M253.776 56.089H195.2a2.114 2.114 0 110-4.228h58.579a2.114 2.114 0 010 4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60278"
        d="M130.477 126.238H103.3a2.114 2.114 0 000 4.228h27.175a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60279"
        d="M130.477 133.916H103.3a2.114 2.114 0 100 4.228h27.175a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60280"
        d="M161.943 126.238h-18.225a2.114 2.114 0 000 4.228h18.225a2.114 2.114 0 100-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60281"
        d="M161.943 133.916h-18.225a2.114 2.114 0 000 4.228h18.225a2.114 2.114 0 100-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60282"
        d="M161.974 91.534h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60283"
        d="M161.974 98.934h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60284"
        d="M161.974 106.333h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60285"
        d="M103.634 85.192H138a2.114 2.114 0 100-4.228h-34.366a2.114 2.114 0 100 4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60286"
        d="M181.877 296.993H94.09a2.13 2.13 0 010-4.26h87.787a2.13 2.13 0 010 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60287"
        d="M253.76 289.459H93.872a1.912 1.912 0 01-1.913-1.912v-.434a1.913 1.913 0 011.913-1.913H253.76a2.13 2.13 0 110 4.259"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60288"
        d="M249.909 221.057h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 010 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60289"
        d="M223.364 221.057h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60290"
        d="M249.909 235.3h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60291"
        d="M223.364 235.3h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60292"
        d="M249.909 171.644h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60293"
        d="M249.909 180.165h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60294"
        d="M249.909 188.685h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60295"
        d="M249.909 197.205h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60296"
        d="M249.909 205.726h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60297"
        d="M223.364 171.644h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60298"
        d="M223.364 180.165h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60299"
        d="M223.364 188.685h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60300"
        d="M223.364 197.205h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60301"
        d="M223.364 205.726h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60302"
        d="M158.749 171.644H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60303"
        d="M158.749 180.165H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60304"
        d="M158.749 188.685H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60305"
        d="M158.749 197.205H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60306"
        d="M158.749 205.726H93.664a2.13 2.13 0 110-4.26h65.085a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60307"
        d="M137.263 156.313h-43.6a2.13 2.13 0 010-4.26h43.6a2.13 2.13 0 010 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60308"
        d="M173.712 119.53H91.534a.5.5 0 01-.5-.5V72.5a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v46.53a.5.5 0 01-.5.5m-81.678-1h81.178V73H92.034z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60309"
        d="M244.09 91.534h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60310"
        d="M244.09 98.934h-58.579a2.114 2.114 0 000 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60311"
        d="M244.09 106.333h-58.579a2.114 2.114 0 100 4.228h58.579a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60312"
        d="M185.75 85.192h34.365a2.114 2.114 0 000-4.228H185.75a2.114 2.114 0 000 4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60313"
        d="M255.89 119.53h-82.178a.5.5 0 01-.5-.5V72.5a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v46.53a.5.5 0 01-.5.5m-81.678-1h81.179V73h-81.179z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60314"
        d="M173.712 145.851H91.534a.5.5 0 01-.5-.5V119.03a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v26.321a.5.5 0 01-.5.5m-81.678-1h81.178V119.53H92.034z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60315"
        d="M212.656 126.238h-27.175a2.114 2.114 0 000 4.228h27.175a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60316"
        d="M212.656 133.916h-27.175a2.114 2.114 0 100 4.228h27.175a2.114 2.114 0 100-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60317"
        d="M244.122 126.238H225.9a2.114 2.114 0 000 4.228h18.226a2.114 2.114 0 000-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60318"
        d="M244.122 133.916H225.9a2.114 2.114 0 000 4.228h18.226a2.114 2.114 0 100-4.228"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60319"
        d="M255.89 145.851h-82.178a.5.5 0 01-.5-.5V119.03a.5.5 0 01.5-.5h82.178a.5.5 0 01.5.5v26.321a.5.5 0 01-.5.5m-81.678-1h81.179V119.53h-81.179z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60320"
        d="M255.89 239.709h-26.545a.5.5 0 01-.5-.5v-12.072a.5.5 0 01.5-.5h26.545a.5.5 0 01.5.5v12.072a.5.5 0 01-.5.5m-26.045-1h25.545v-11.072h-25.545z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60321"
        d="M229.345 239.709H202.8a.5.5 0 01-.5-.5v-12.072a.5.5 0 01.5-.5h26.545a.5.5 0 01.5.5v12.072a.5.5 0 01-.5.5m-26.045-1h25.545v-11.072H203.3z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60322"
        d="M249.909 247.375h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60323"
        d="M223.364 247.375h-14.582a2.13 2.13 0 110-4.26h14.582a2.13 2.13 0 110 4.26"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60324"
        d="M255.89 251.781h-26.545a.5.5 0 01-.5-.5v-12.072a.5.5 0 01.5-.5h26.545a.5.5 0 01.5.5v12.072a.5.5 0 01-.5.5m-26.045-1h25.545v-11.072h-25.545z"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60325"
        d="M229.345 251.781H202.8a.5.5 0 01-.5-.5v-12.072a.5.5 0 01.5-.5h26.545a.5.5 0 01.5.5v12.072a.5.5 0 01-.5.5m-26.045-1h25.545v-11.072H203.3z"
        fill="#c5c5c4"
      />
      <path data-name="Path 60326" d="M255.89 162.348H91.534a.5.5 0 010-1H255.89a.5.5 0 110 1" fill="#c5c5c4" />
      <path data-name="Path 60327" d="M255.89 211.762H91.534a.5.5 0 010-1H255.89a.5.5 0 110 1" fill="#c5c5c4" />
      <path
        data-name="Path 60328"
        d="M192.873 234.289h-9.819a1.435 1.435 0 110-2.869h9.819a1.435 1.435 0 010 2.869"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60329"
        d="M125.122 234.289H92.968a1.435 1.435 0 010-2.869h32.154a1.435 1.435 0 010 2.869"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60330"
        d="M192.873 240.573h-9.819a1.435 1.435 0 110-2.869h9.819a1.435 1.435 0 010 2.869"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60331"
        d="M192.873 250.412h-9.819a1.435 1.435 0 110-2.869h9.819a1.435 1.435 0 010 2.869"
        fill="#c5c5c4"
      />
      <path
        data-name="Path 60332"
        d="M125.122 240.573H92.968a1.435 1.435 0 010-2.869h32.154a1.435 1.435 0 010 2.869"
        fill="#c5c5c4"
      />
      <path data-name="Path 60333" d="M194.307 228.506H91.534a.5.5 0 110-1h102.773a.5.5 0 010 1" fill="#c5c5c4" />
      <path data-name="Path 60334" d="M194.307 244.487H91.534a.5.5 0 010-1h102.773a.5.5 0 010 1" fill="#c5c5c4" />
      <path
        data-name="Path 60335"
        d="M101.231 53.07c-1.868-.485-2.468-.987-2.468-1.769 0-.9.831-1.522 2.221-1.522 1.169 0 1.753.444 1.967 1.152a.761.761 0 00.716.576h.246a.78.78 0 00.741-1.045 3.288 3.288 0 00-2.436-2.09V47.8a1.234 1.234 0 10-2.468 0v.543c-1.6.346-2.88 1.382-2.88 2.97 0 1.9 1.571 2.847 3.867 3.4 2.057.493 2.469 1.217 2.469 1.983 0 .567-.4 1.472-2.222 1.472-1.358 0-2.057-.485-2.329-1.176a.809.809 0 00-.74-.551h-.23a.785.785 0 00-.733 1.069 3.7 3.7 0 002.8 2.082v.551a1.234 1.234 0 102.468 0v-.535c1.6-.3 2.88-1.234 2.88-2.921 0-2.336-2-3.135-3.867-3.62"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60336"
        d="M110.429 53.07c-1.868-.485-2.468-.987-2.468-1.769 0-.9.831-1.522 2.221-1.522 1.169 0 1.753.444 1.967 1.152a.761.761 0 00.716.576h.246a.78.78 0 00.741-1.045 3.288 3.288 0 00-2.436-2.09V47.8a1.234 1.234 0 10-2.468 0v.543c-1.6.346-2.88 1.382-2.88 2.97 0 1.9 1.572 2.847 3.867 3.4 2.057.493 2.469 1.217 2.469 1.983 0 .567-.4 1.472-2.222 1.472-1.357 0-2.057-.485-2.328-1.176a.81.81 0 00-.741-.551h-.23a.785.785 0 00-.733 1.069 3.7 3.7 0 002.8 2.082v.551a1.234 1.234 0 102.468 0v-.535c1.605-.3 2.88-1.234 2.88-2.921 0-2.336-2-3.135-3.867-3.62"
        fill="#1d1d1b"
      />
      <path
        data-name="Path 60337"
        d="M119.628 53.07c-1.868-.485-2.468-.987-2.468-1.769 0-.9.831-1.522 2.221-1.522 1.169 0 1.753.444 1.967 1.152a.761.761 0 00.716.576h.246a.78.78 0 00.741-1.045 3.288 3.288 0 00-2.436-2.09V47.8a1.234 1.234 0 10-2.468 0v.543c-1.6.346-2.88 1.382-2.88 2.97 0 1.9 1.572 2.847 3.867 3.4 2.057.493 2.469 1.217 2.469 1.983 0 .567-.4 1.472-2.222 1.472-1.358 0-2.057-.485-2.328-1.176a.811.811 0 00-.741-.551h-.23a.785.785 0 00-.733 1.069 3.7 3.7 0 002.8 2.082v.551a1.234 1.234 0 102.468 0v-.535c1.605-.3 2.88-1.234 2.88-2.921 0-2.336-2-3.135-3.867-3.62"
        fill="#1d1d1b"
      />
    </g>
  </svg>
)
export { Invoice }
